import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash'

import Dropzone from 'react-dropzone'
import { TableRow, TableCell, Table, TableBody, TableHead, Button, Box, TableContainer, IconButton } from '@material-ui/core';
import { VisibilityRounded } from '@material-ui/icons';
import { FactList } from '../Menu/Stock/purchases/InputFactID';
import { Alert } from '@material-ui/lab';
import TemplateList from './TemplateList';
import { toast } from 'react-toastify';

class ImportFilesStocks extends Component {
    state = {
        file: [],
        content: "",
        error: "",
        openCheckFact: false,
        fact: "",
    }
    componentDidMount = () => {}
    onDrop = (event) => {
        console.log("[INFO], ", event)
        this.setState({
            // substring to is to limit to 3 characters
            file: event
        });
    }
    parseContent = () => {
        console.log("[PARSE] content, ", this.state.file[0])
        if (this.state.file[0] !== "" && typeof this.state.file[0] !== "undefined") {
            const reader = new FileReader()
            reader.onload = (e) => {
                const text = (e.target.result)
                console.log(text)
                this.setState({content: text})
            };
            let info = reader.readAsText(this.state.file[0])
            console.log("[PARSE] result, ", info)
        }
    }

    formatError = (errorValue) => {
        if (!errorValue) {
            return "Unknown upload error";
        }
        if (typeof errorValue === "string") {
            return errorValue;
        }
        if (typeof errorValue.content === "string" && errorValue.content !== "") {
            return errorValue.content;
        }
        try {
            return JSON.stringify(errorValue);
        } catch (e) {
            return "Unknown upload error";
        }
    }

    uploadContent = async() => {
        console.log("[PARSE] upload FILES, ", this.state.file[0])

        const dataFile = new FormData()
        dataFile.append('file', this.state.file[0])

        const response = await fetch('/download/upload/storehouse', {
            method: 'POST',
            headers: {
            },
            body: dataFile,
            credentials: 'same-origin'
        });
        console.log("[INFO], resquest has been sent");
        const resp = await response.json();
        console.log(resp);
        if (resp.msg != "OK") {
            console.log("[SUCESS], handleSubmitDocument response ", resp)
            const errorMessage = this.formatError(resp.error);
            this.setState({error: errorMessage});
            toast.error(`Upload failed: ${errorMessage}`)
            return;
        }
        toast.success("Upload is ok")
        this.setState({file: [], error: ""});
    }

    getDelimiter = (lines) => {
        const firstNonEmptyLine = lines.find(line => line && line.trim() !== "");
        if (!firstNonEmptyLine) {
            return ",";
        }
        const semicolonCount = (firstNonEmptyLine.match(/;/g) || []).length;
        const commaCount = (firstNonEmptyLine.match(/,/g) || []).length;
        return semicolonCount > commaCount ? ";" : ",";
    }

    render() {
        console.log('====================================');
        console.log("[STATE]", this.state);
        console.log('====================================');

        const { openCheckFact, fact, openTemp } = this.state;
        const files = this.state.file .map(file => (
                <li key={file.name}>
                    {file.name} - {file.size} bytes
                </li>
            ));

        let content = [];
        let header = [];
        let arrayOfLines = this.state.content.split(/\r?\n/);
        const delimiter = this.getDelimiter(arrayOfLines);
        arrayOfLines.forEach( (item, ind) => {
            let infos = item.split(delimiter);
            // console.log({infos});
            if (ind === 0) {                
                header.push(
                    <TableRow key={ind}>
                        {infos.map(info => <TableCell>{info}</TableCell> )}
                        <TableCell></TableCell>
                    </TableRow>
                )
            } else {
            // } else if (infos.length !== 1 && infos[0] !== '') {
                content.push(
                    <TableRow key={ind}>
                        {infos.map(info => 
                            <TableCell>
                                {info.split('+').map( item =>
                                    <Box>{item}</Box>
                                )}
                            </TableCell> 
                        )}
                        {(arrayOfLines[0].startsWith("ID ACHAT")) &&
                            <TableCell>
                                <IconButton onClick={() => this.setState({ openCheckFact: true, fact : infos[1].replaceAll("+", ",")})}>
                                    <VisibilityRounded />
                                </IconButton>
                            </TableCell> 
                        }
                    </TableRow>
                )
            }
        })
        console.log(header);
        return (
            <div className="row">
                {openCheckFact && 
                    <FactList
                        fact_id_5000={fact}
                        handleClose={() => this.setState({ openCheckFact: false, fact : ""})}
                    />
                }
                {openTemp && 
                    <TemplateList
                        handleClose={() => this.setState({ openTemp: false})}
                    />
                }
                {/* Upload files */}
                <Box style={{textAlign: 'right'}}>
                    <Button onClick={() => this.setState({ openTemp : true})} color={'secondary'}>
                        Templates
                    </Button>
                </Box>
                <Dropzone onDrop={this.onDrop}>
                    {({getRootProps, getInputProps}) => (
                        <section className="container">
                            <div
                                {...getRootProps({className: 'dropzone'})}
                                style={{
                                "borderStyle": "dashed",
                                "borderRadius": "10px",
                                "borderColor": "#aaa",
                                "textAlign": "center",
                                "fontSize": "20px",
                                height: "100px",
                            }}>
                                <input {...getInputProps()} accept=".csv"/>
                                <p>Deposer vos fichiers</p>
                            </div>
                            <aside>
                                <h4>Files</h4>
                                <ul>{files}</ul>
                            </aside>
                        </section>
                    )}
                </Dropzone>
                <div style={{ display: 'flex'}}>
                    <Box p={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            onClick={this.parseContent}
                        >
                            Parse Document
                        </Button>
                    </Box>
                    <Box p={1}>
                        <Button
                            variant="contained"
                            color="secondary"
                            type="submit"
                            onClick={this.uploadContent}
                        >
                            Upload Document
                        </Button>
                    </Box>

                </div>
                {this.state.error &&
                    <Alert severity="error">
                        {this.state.error}
                    </Alert>
                }
                <TableContainer>
                    <Table>
                        <TableHead>
                            {header}
                        </TableHead>
                        <TableBody>
                            {content}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}

export default ImportFilesStocks;